(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'},
            'checkBrowser': {
                url: 'api/users/check-browser/:browserUuid', method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return {result: data};
                }
            },
            'sendSmsCode': {
                url: 'api/users/send-sms-code/:browserUuid', method: 'GET'
            },
            'verifyCode': {
                url: 'api/users/verify-code/', method: 'POST'
            },
        });

        return service;
    }
})();
